import React from 'react';
import { colors, spacing } from '../design-system/tokens';

interface SectionDividerProps {
  className?: string;
  margin?: 'sm' | 'md' | 'lg' | 'xl';
  style?: React.CSSProperties;
}

export const SectionDivider: React.FC<SectionDividerProps> = ({ 
  className = '',
  margin = 'lg',
  style = {}
}) => {
  return (
    <div 
      className={className}
      style={{ 
        height: '1px', 
        backgroundColor: colors.border.default, 
        width: '100%',
        margin: `${spacing[margin]} 0`,
        ...style
      }} 
    />
  );
};